import { FieldValues } from "react-hook-form";
import { PlanningModeEnum } from "shared/enums/globalEnums";
import { GenericPlanningValue } from "./types";

export interface PlanningApiItem {
  chronicle_filename: string | null;
  start_date: Date;
  end_date: Date;
  mode: PlanningModeEnum;
  target_soc?: number | null;
  operator_name: string;
  overidable: boolean;
  fcrn_engagement?: number | null;
  fcrd_up_engagement?: number | null;
  fcrd_down_engagement?: number | null;
  afrr_engagement_up?: number | null;
  afrr_engagement_down?: number | null;
  initial_soc_restoration_power?: number | null;
  reactivity_delay: number;
}

export function mapValuesToApi(values: FieldValues): PlanningApiItem[] {
  const activeEntries = Object.values(values).filter((v: any): v is GenericPlanningValue => v?.active && v?.mode);

  return activeEntries.map((v: GenericPlanningValue): PlanningApiItem => {
    const isSoc = v.mode === PlanningModeEnum.soc_management;
    const isFcrN = v.mode === PlanningModeEnum.fingrid_fcrn;
    const isFcrD = v.mode === PlanningModeEnum.fingrid_fcrd;
    const isAfrr = v.mode === PlanningModeEnum.fingrid_afrr;

    const item: PlanningApiItem = {
      chronicle_filename: v.chronicleFilename ?? null,
      start_date: v.start_date,
      end_date: v.end_date,
      mode: v.mode,
      // IMPORTANT: undefined => omitted
      target_soc: isSoc ? v.targetSoc : undefined,
      operator_name: "",
      overidable: false,
      fcrn_engagement: isFcrN ? v.fcrn_engagement : undefined,
      fcrd_up_engagement: isFcrD ? v.fcrd_up_engagement : undefined,
      fcrd_down_engagement: isFcrD ? v.fcrd_down_engagement : undefined,
      afrr_engagement_up: isAfrr ? v.afrr_engagement_up : undefined,
      afrr_engagement_down: isAfrr ? v.afrr_engagement_down : undefined,
      initial_soc_restoration_power: isAfrr ? v.initialSocRestorationPower : undefined,
      reactivity_delay: 0,
    };

    return item;
  });
}
